import { render, staticRenderFns } from "./HistorialPiezaView.vue?vue&type=template&id=b94e1bc4&scoped=true&lang=pug"
import script from "./HistorialPiezaView.vue?vue&type=script&lang=js"
export * from "./HistorialPiezaView.vue?vue&type=script&lang=js"
import style0 from "./HistorialPiezaView.vue?vue&type=style&index=0&id=b94e1bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94e1bc4",
  null
  
)

export default component.exports